var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-page',{attrs:{"title":_vm.title}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"id":"deptAreaDistribution"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }